import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import queryString from "query-string";

import { DateUtils } from "@/utils/date";
import { user } from "@/utils/firebase/user";

import { apiBaseUrl } from "./apiBaseUrl";

class RemoteUtils {
  private static async addTokenToConfig(
    config: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> {
    const token = await user.currentUser?.getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }

  private static async modifyTime(
    config: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> {
    const {
      headers: { tzCode },
      params,
    } = config;

    if (tzCode) {
      const { startTime, endTime } = params;
      params.startTime = DateUtils.zonedToUtcStartTime(startTime, tzCode);
      params.endTime = DateUtils.zonedToUtcEndTime(endTime, tzCode);
      delete config.headers.tzCode;
    }

    return config;
  }

  static createBaseClient(): AxiosInstance {
    const baseClient = axios.create({
      baseURL: `${apiBaseUrl()}/v1`,
    });
    baseClient.interceptors.request.use(RemoteUtils.addTokenToConfig);
    return baseClient;
  }

  static createClient(): AxiosInstance {
    const client = axios.create({
      baseURL: `${apiBaseUrl()}/v1/vis`,
    });
    client.interceptors.request.use(RemoteUtils.addTokenToConfig);
    client.interceptors.request.use(RemoteUtils.modifyTime);
    client.defaults.paramsSerializer = (params) => {
      return queryString.stringify(params, {
        encode: false,
        arrayFormat: "none",
        skipNull: true,
      });
    };
    return client;
  }
}

const baseClient = RemoteUtils.createBaseClient();
const client = RemoteUtils.createClient();

export { baseClient, client };
